<template>
  <div class="giveaway-list" :data-show="show">
    <template v-if="['ready', 'liveStarting', 'live', 'liveStopping'].includes(broadcast.status.life_cycle_status)">
      <Button class="no-border-radius white f-w bold" icon="plusCircle" @click="newGiveaway">Add new giveaway</Button>
    </template>
    <div class="giveaways nice-scrollbar">
      <template v-if="fetching">
        <div class="loading-spinner m-a-a"></div>
      </template>
      <template v-else>
        <template v-if="giveaways.length > 0">
          <div class="app-item" v-for="giveaway in giveaways" :key="giveaway.id" @click="openGiveaway(giveaway.id)">
            <div class="info">
              <h2>{{ giveaway.title }}</h2>
              <p class="">{{ giveaway.state | giveawayState }}</p>
            </div>
            <!--<div class="controls">
              <i :class="`icon-megaphone-tilted ${giveaway.state === 'published' && !['complete', 'abandoned'].includes(broadcast.status.life_cycle_status) ? '' : 'gray'}`" @click.prevent.stop="promoteGiveaway(giveaway)" />
            </div>-->
          </div>
        </template>
        <template v-else>
          <div class="d-f ai-c jc-c f-1 ta-c p-a-4 page-placeholder-text">
            <p>No forms created yet.</p>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
    /**
     * Get current list of forms
     * @returns {Array}
     */
    giveaways() {
      const stateOrder = {
        unpublished: 0,
        published: 1,
        closed: 2,
        completed: 3,
      };

      const giveaways = this.$store.getters['Giveaway/giveaways'];

      return giveaways.sort((a, b) => stateOrder[a.state] - stateOrder[b.state]);
    },
  },
  methods: {
    newGiveaway() {
      this.$store.commit('Giveaway/createGiveaway', true);
    },
    openGiveaway(id) {
      this.$store.dispatch('Giveaway/getGiveaway', { id });
    },
    promoteForm(giveaway) {
      if (giveaway.state !== 'published' || ['complete', 'abandoned'].includes(this.broadcast.status.life_cycle_status)) {
        return;
      }

      this.$store.dispatch('Giveaway/promoteGiveaway', giveaway.id);
    },
  },
  async mounted() {
    await this.$store.dispatch('Giveaway/getList', {
      broadcast_id: this.broadcast.id,
    });

    this.fetching = false;
  },
  data() {
    return {
      fetching: true,
    };
  },
  filters: {
    /**
     * Truncate long strings
     * @param {String} string
     * @param {Number} length Defaults to 100
     * @returns {String}
     */
    giveawayState(state) {
      switch (state) {
        case 'unpublished':
          return 'Unpublished';
        case 'published':
          return 'Published';
        case 'closed':
          return 'Closed';
        case 'completed':
          return 'Completed';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.giveaway-list {
  background: #F3F5F9;
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, .10);
  flex: 1;
  display: none;
  flex-direction: column;
  overflow: hidden;

  &[data-show="true"] {
    display: flex;
  }

  .giveaways {
    overflow: auto;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-top: 1px solid #C1C5D7;
    flex: 1;
  }
}
</style>
